import React from "react";
import styled from "styled-components";
import { Sticky } from "react-sticky";

const Container = styled.div`
  margin: 0 auto;
  max-width: 1360px;
  height: 96px;
  position: relative;
  bottom: 30px;
  margin-bottom: -90px;
  z-index: 10000;
  padding-left: 20px;
  padding-right: 20px;
  box-shadow: 15px 15px #ebe8e1;
  ${({ isSticky }) =>
    isSticky &&
    `
    box-shadow: none;
    width: 100% !important;
    max-width: none;
    background-color: #fff;
    padding-left: 20px;
    padding-right: 20px;
    border-top: 8px solid #f76367;
    > div {
      max-width: 1260px;
      margin: 0 auto;
    }
  `} @media (max-width: 680px) {
    display: none;
  }
`;

export default ({ children, id, style }) => (
  <Sticky>
    {({ style, isSticky, ...rest }) => (
      <Container
        id={id}
        style={style}
        isSticky={isSticky}
        className="pa2 bg-white center"
      >
        <div className="flex flex-row-ns flex-column justify-center">
          {children}
        </div>
      </Container>
    )}
  </Sticky>
);



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/InsidersList/internal/FilterBar.js